import axios from 'axios'
import { CDN } from '../cdn/cdn'

export const fetchDictionaries = async lang => {
  const baseUrl = CDN.getCdnUrl() === '/' ? window.location.origin : CDN.getCdnUrl()
  const [dictionary, teamNameMap] = await Promise.all([axios.get(`${baseUrl}/dictionaries/${lang}.json`), axios.get(`${baseUrl}/dictionaries/teams_greek.json`)])

  return { dictionary: dictionary.data, teamNameMap: teamNameMap.data }
}
